<template>
  <div id="detail">
    <div class="row">
      <div class="col">
        <router-link to="/" class="link-back">
          <MaterialSvg
            class="icon-white"
            name="keyboard_backspace"
            :width="24"
          />
          {{ $t('detail.back') }}
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2 class="mt-5">{{ device.title }}</h2>
      </div>
    </div>
    <div class="row">
      <Scent :background="device.background" :scent="device.scent"></Scent>
      <Cartridge
        :cartridgeFill="device.cartridgeFill"
        :error="device.error"
        :hub-id="device.key"
        :current-scent="device.scent"
        :cartridge-size="device.cartridgeSize"
      ></Cartridge>
      <Connection
        :online="device.online"
        :connectionType="device.connectionType"
        :wifiStrength="device.wifiStrength"
        :error="device.error"
        @instructions="openInstructions"
      ></Connection>
    </div>
    <div class="row mb-4">
      <div class="col">
        <div class="card">
          <h3 class="card-title">{{ $t('detail.schedules') }}</h3>
          <div class="row">
            <div class="col">
              <a
                @click="addSchedule"
                :class="{ disabled: maxSettingsReached }"
                class="action-link"
                ><MaterialSvg class="icon-cyaan" name="add" :width="24" />
                {{ addScheduleButton }}
              </a>
            </div>
          </div>
          <Spinner v-if="!schedules" />
          <Schedules
            v-if="schedules && device.currentSettings >= 0"
            :schedules="schedules.schedules"
            :max-settings="device.maxSettings"
            :current-settings="device.currentSettings"
            @delete-schedule="deleteSchedule"
          />
        </div>
      </div>
    </div>
    <InstructionVideo
      v-if="showInstructions"
      @instructions="openInstructions"
    />
  </div>
</template>

<script>
import Scent from '@/components/Scent.vue';
import Cartridge from '@/components/Cartridge.vue';
import Connection from '@/components/Connection.vue';
import Schedules from '@/components/Schedules';
import InstructionVideo from '@/components/InstructionVideo';

import { Action as DeviceAction } from '@/store/hubs/types';
import { Getter as DeviceGetter } from '@/store/hubs/types';
import { Action as ScheduleAction } from '@/store/schedule/types';
import { Getter as ScheduleGetter } from '@/store/schedule/types';

export default {
  name: 'Detail',
  components: {
    Scent,
    Cartridge,
    Connection,
    Schedules,
    InstructionVideo,
  },
  data() {
    return {
      showInstructions: false,
    };
  },
  computed: {
    device() {
      return this.$store.getters[`${DeviceGetter.DEVICE}`](
        this.$route.params.hash
      );
    },
    schedules() {
      return this.$store.getters[`${ScheduleGetter.GET_SCHEDULES}`](
        this.$route.params.hash
      );
    },
    maxSettingsReached() {
      if (this.device.currentSettings >= this.device.maxSettings) {
        return true;
      }
      return false;
    },
    addScheduleButton() {
      if (this.maxSettingsReached) {
        return this.$t('error.max-schedules');
      }
      return this.$t('button.add-schedule');
    },
  },
  mounted() {
    this.getDevice();
  },
  methods: {
    getDevice() {
      this.$store.dispatch(
        `${DeviceAction.GET_DEVICE}`,
        this.$route.params.hash
      );
    },
    addSchedule() {
      if (!this.maxSettingsReached) {
        this.$store
          .dispatch(`${ScheduleAction.CREATE_SCHEDULE}`, {
            hash: this.$route.params.hash,
            deviceId: this.device.key,
          })
          .then((result) => {
            console.log('Added schedule');
            this.getDevice();
          });
      }
    },
    deleteSchedule(scheduleId) {
      this.$store
        .dispatch(`${ScheduleAction.DELETE_SCHEDULE}`, {
          hash: this.$route.params.hash,
          schedule: scheduleId,
        })
        .then((result) => {
          console.log('deleted');
          this.getDevice();
        });
    },
    openInstructions(value) {
      this.showInstructions = value;
    },
  },
};
</script>

<style scoped lang="scss">
.action-link {
  display: inline-block;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>